/**
 * Application-wide constants
 * Single source of truth for configuration values
 */

// =============================================================================
// SUPABASE
// =============================================================================
export const SUPABASE_URL = 'https://wbvrlcospepaqsooxhvg.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndidnJsY29zcGVwYXFzb294aHZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ2MjIwNjEsImV4cCI6MjA4MDE5ODA2MX0.Cw0X96mff4tfkELPoc_BQWZmSlSO0FJX6ei_EwG1Lqo';

// =============================================================================
// API
// =============================================================================
export const API_BASE_URL = import.meta.env.DEV
  ? 'http://localhost:8787'
  : 'https://relo-api.quomx.workers.dev';

export const IMPORTER_URL = 'https://upload.relo.mx';

// =============================================================================
// CLIENTS
// =============================================================================
/**
 * Samsung is the default/primary client
 * Used as fallback when client_id is not specified
 */
export const DEFAULT_CLIENT_ID = 3;
export const DEFAULT_CLIENT_SLUG = 'samsung';

// =============================================================================
// PAGINATION
// =============================================================================
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

// =============================================================================
// FILE UPLOAD
// =============================================================================
export const MAX_UPLOAD_SIZE_MB = 100;
export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;
export const CHUNK_SIZE_BYTES = 8 * 1024 * 1024; // 8MB chunks for multipart
